import React from 'react';
import { CONFIGURATOR_EXTRAS_META } from '../../utils/estimator';
import { sectionTitle } from './estimateUi';

export default function StepExtras({ isUA, extras, onToggle }) {
  return (
    <div className="py-10 border-b border-border/60">
      <p className={sectionTitle}>{isUA ? 'Додатково' : 'Extras'}</p>
      <ul className="space-y-4">
        {CONFIGURATOR_EXTRAS_META.map(({ key, labelUA, labelEN }) => (
          <li key={key}>
            <label className="flex items-start gap-3 cursor-pointer group">
              <input
                type="checkbox"
                checked={!!extras[key]}
                onChange={(e) => onToggle(key, e.target.checked)}
                className="mt-1 w-4 h-4 border-border text-foreground focus:ring-foreground/20 rounded-none accent-foreground"
              />
              <span className="text-sm text-foreground/90 transition-colors duration-300 group-hover:text-foreground">
                {isUA ? labelUA : labelEN}
              </span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}
